import { render, staticRenderFns } from "./HeadCountSegLocationComponet.vue?vue&type=template&id=6ffb46d4&"
import script from "./HeadCountSegLocationComponet.vue?vue&type=script&lang=js&"
export * from "./HeadCountSegLocationComponet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports